import { PopulationWidgetParams } from './population.model';

/**
 * Structured presets for the PopulationWidgetComponent.
 *
 * Each preset is a {@link PopulationWidgetParams} object.
 * These are the **single source of truth** — both Storybook stories
 * and the lesson JSON import/reference these presets.
 */

// ── Base ─────────────────────────────────────────────────

export const POPULATION_BASE: PopulationWidgetParams = {
  populationSize: 300,
};

// ── Lesson steps ─────────────────────────────────────────

export const POPULATION_INTRO: PopulationWidgetParams = {
  ...POPULATION_BASE,
  dotOpacity: 0.7,
};

export const SAMPLE_INTRO: PopulationWidgetParams = {
  ...POPULATION_BASE,
  sampleMethod: 'random',
  samplePercentage: 10,
  sampleColor: '#3b82f6',
  sampleSeed: 149,
};

export const SAMPLE_BENEFIT: PopulationWidgetParams = {
  ...SAMPLE_INTRO,
};

export const SIMPLE_RANDOM: PopulationWidgetParams = {
  ...POPULATION_BASE,
  sampleMethod: 'random',
  samplePercentage: 10,
  sampleColor: '#22c55e',
  sampleSeed: 149,
};

export const SYSTEMATIC_SAMPLING: PopulationWidgetParams = {
  ...POPULATION_BASE,
  sampleMethod: 'systematic',
  sampleInterval: 10,
  sampleColor: '#3b82f6',
};

export const STRATIFIED_SAMPLING: PopulationWidgetParams = {
  ...POPULATION_BASE,
  demographicName: 'Gender',
  demographicCategories: [
    { label: 'Female', percentage: 60, color: '#ec4899' },
    { label: 'Male', percentage: 40, color: '#3b82f6' },
  ],
  sampleMethod: 'stratified',
  samplePercentage: 10,
  sampleColor: '#22c55e',
  sampleSeed: 149,
};

export const BIASED_SAMPLE: PopulationWidgetParams = {
  ...POPULATION_BASE,
  sampleMethod: 'biased',
  samplePercentage: 10,
  sampleColor: '#ef4444',
  showBiasZone: true,
};

export const RELIABILITY: PopulationWidgetParams = {
  ...POPULATION_BASE,
  sampleMethod: 'random',
  samplePercentage: 10,
  sampleColor: '#22c55e',
  sampleSeed: 149,
  reliabilityBars: [
    { label: 'Random Sample 1', width: 50, color: '#22c55e' },
    { label: 'Random Sample 2', width: 47, color: '#22c55e' },
    { label: 'Random Sample 3', width: 51.5, color: '#22c55e' },
    { label: 'Biased Sample', width: 72, color: '#ef4444' },
  ],
};

// ── Demographic presets (for Storybook) ──────────────────

export const GENDER_DEMOGRAPHICS: PopulationWidgetParams = {
  populationSize: 200,
  demographicName: 'Gender',
  demographicCategories: [
    { label: 'Male', percentage: 55, color: '#3b82f6' },
    { label: 'Female', percentage: 45, color: '#ec4899' },
  ],
};

export const BLOOD_TYPES: PopulationWidgetParams = {
  populationSize: 300,
  demographicName: 'Blood Type',
  demographicCategories: [
    { label: 'O', percentage: 44, color: '#ef4444' },
    { label: 'A', percentage: 42, color: '#3b82f6' },
    { label: 'B', percentage: 10, color: '#22c55e' },
    { label: 'AB', percentage: 4, color: '#a855f7' },
  ],
};
